enum Role {
  'ADMIN' = 'ADMIN',
  'MEMBER' = 'MEMBER',
  'CONTRACTOR' = 'CONTRACTOR',
  'OWNER' = 'OWNER',
  'ACCOUNTS' = 'ACCOUNTS',
  'BOOKER' = 'BOOKER'
}
export default Role;
